import { Button, PageHeader } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import JournalVoucherEntryView from '../../components/account/journal/JournalVoucherEntryView'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import TaxInvoiceEntryView from '../../components/taxinvoice/TaxInvoiceEntryView'
import BTATournamentEntryView from '../../components/btatournamentcomponent/BTATournamentEntryView'


const BTATournament = () => {
  return (
    <div className='inside-main-content'>

      <AdminBreadCrumb />

        <div className="box-style" >
            <PageHeader
            ghost={false}
            onBack={() => window.history.back()}
            title="General Receipt Entry"
            subTitle=""
            extra={[
                <Link to={`/tournament/list`} key="tournament_list">
                  <Button key="tournament-list-button-1" shape='round' className='custom-button-white'> List</Button>
                </Link>
            ]}
            >

            </PageHeader>

            <BTATournamentEntryView />
        </div>
    </div>
  )
}

export default BTATournament